// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ei-2";
export var aiChatCartContainerExit = "_ei-4";
export var aiChatContainerLarge = "_ei-0";
export var aiChatContainerSmall = "_ei-1";
export var aiChatIcon = "_ei-6";
export var slideInFromRight = "_ei-3";
export var slideOutToRight = "_ei-5";